var exports = {
  "MI": "xaee3c4fa--9b4d10--sub-dialog-content-header",
  "A1": "xaee3c4fa--9b4d10--sub-dialog-content-text",
  "pA": "xaee3c4fa--9b4d10--sub-dialog-content-controls",
  "gf": "xaee3c4fa--9b4d10--c-digest-form-container",
  "uQ": "xaee3c4fa--9b4d10--c-digest-form-license",
  "Zf": "xaee3c4fa--9b4d10--c-digest-form-license-link",
  "lj": "xaee3c4fa--9b4d10--c-digest-success-header",
  "dK": "xaee3c4fa--9b4d10--c-digest-success-text",
  "kt": "xaee3c4fa--9b4d10--c-digest-fail-text",
  "iu": "xaee3c4fa--9b4d10--c-digest-email",
  "pD": "xaee3c4fa--9b4d10--mobile-content",
  "dX": "xaee3c4fa--9b4d10--desktop-content",
  "h2": "xaee3c4fa--9b4d10--sub-dialog-fail-text",
  "Gh": "xaee3c4fa--9b4d10--c-digest-form",
  "aS": "xaee3c4fa--9b4d10--break-mobile-hidden",
};

module.exports = exports;
